import React, { lazy, Suspense } from "react";
import { useNavigate, useLocation, Outlet } from "react-router";
import { useSelector } from "react-redux";
import { selectors } from "@ReduxStore/reducers";
import { ROUTES, DEALS_SSO_LOCATION_TRACKING_KEY_NAME } from "@Src/constants";
import { mediaBreakpoints } from "@accessdev/arc-ui-react/utils/js";
import Media from "react-media";
// import MobileBanner from "@Components/MobileBanner";
import Footer from "@Components/Footer/Footer";
import SessionExpired from "@Components/SessionExpired";
import { SkipToHere } from "@Src/components/SkipToContent";
import FiveNineChat from "@Components/FiveNineChat";
import Loading from "@Components/loading";
import { useLogImageLoadErrors } from "@Src/hooks/useTrackImageLoadFailure";

const Header = lazy(() => import("@Src/components/Header/Header"));
const MobileHeader = lazy(() => import("@Components/Header/MobileHeader"));

export default () => {
  useLogImageLoadErrors();
  const location = useLocation();
  const navigate = useNavigate();
  const isChatEnabled = process.env.REACT_APP_CHAT_ENABLED === "true";
  const userAuthenticated = useSelector(selectors.hasAuthenticatedUser);

  React.useEffect(() => {
    if (!userAuthenticated) {
      if (location.pathname !== ROUTES.DIRECTOR_PATH) {
        window.localStorage.setItem(DEALS_SSO_LOCATION_TRACKING_KEY_NAME, JSON.stringify(location));
      }
    } else {
      window.localStorage.removeItem(DEALS_SSO_LOCATION_TRACKING_KEY_NAME);
    }
  }, [location, userAuthenticated]);

  return (
    <>
      {/*
        Per PD-1401, temporarily hiding the mobile banner until the mobile app
        is in a better spot.
       <MobileBanner /> 
      */}
      <Media query={mediaBreakpoints.forPhoneOnly}>
        {(isPhone) => (
          <Suspense>
            {isPhone ? <MobileHeader navigate={navigate} location={location} /> : <Header />}
          </Suspense>
        )}
      </Media>
      <SkipToHere>
        <Suspense fallback={<Loading minHeightDesktop />}>
          <Outlet />
        </Suspense>
      </SkipToHere>
      <Footer />
      {isChatEnabled && <FiveNineChat />}
      <SessionExpired />
    </>
  );
};
